import { ReactElement } from "react";
import Container from "../atoms/Container";
import styled from "styled-components";
import Icon from "../atoms/Icon";
import { pauseCircleOutline, volumeHighOutline } from "ionicons/icons";
import useVocalisation from "../../hooks/useVocalisation";
import { useConfig } from "../../contexts/ConfigContext";
import ContentRenderer from "../organisms/ContentRenderer/ContentRenderer";
import { toPlainText } from "../../helper/richContentText";
import { RichContentData } from "../../types/richContent";

interface DisplayContentPRops {
  editorJsData: RichContentData;
  buttonComp?: ReactElement;
}

const DisplayContent = ({
  editorJsData,
  buttonComp,
}: DisplayContentPRops) => {

  const { readText, isReading, stopReading } = useVocalisation();
  const { selectedRole } = useConfig();

 const isVocalisationEnabled = selectedRole?.attributes?.is_vocalisation_enabled === false ? false : true;

  const handleRead = () => readText(toPlainText(editorJsData));

  return (
    <Container>
      <Buttons>
        {isVocalisationEnabled &&
          (isReading ? (
            <IconButton icon={pauseCircleOutline} onClick={stopReading} />
          ) : (
            <IconButton icon={volumeHighOutline} onClick={handleRead} />
          ))}
      </Buttons>
      <div
        style={{
          flex: 1,
          marginBottom: 20,
          padding: 20,
          overflow: "auto",
          // Breakout contract for full-bleed blocks (hero width='full'): declares how
          // much padding a block must negate to reach this container's edges.
          ["--content-inset" as never]: "20px",
          ["--content-inset-top" as never]: "20px",
        }}
      >
        <ContentRenderer data={editorJsData} />
      </div>
      {buttonComp}
    </Container>
  );
};

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 20px;
`;

const IconButton = styled(Icon)`
  font-size: 26px;
  color: ${(props) => props.theme.primary.main};
  &:active {
    opacity: 0.5;
  }
`;

export default DisplayContent;
